// extracted by mini-css-extract-plugin
export default {"fields":"IikWZt","time":"_PjGer","mobile":"y44T03"};